// extracted by mini-css-extract-plugin
export default {"posReports":"style--posReports--5c28b0","report":"style--report--2c95cb","goBackLink":"style--goBackLink--5ec50e"};